import { Stack, styled } from 'components/base';

export const StyledStack = styled(Stack)({
  // flexDirection: 'row',
  // justifyContent: 'right',
  // alignItems: 'center',
  // gap: 2,
  padding: '8px 24px',
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
});
